<template>
  <div class="custom-progress-bar-back" :style="styleObject">
    <div class="custom-progress-bar" :style="withoutColor?'background-color: var(--goalBackgroundColor3)':''">
    </div>
  </div>

</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        name: "progressBarStep",
        props: {
            value: Number,
            hue: {type: Number, default: 0},
            withoutColor: {type: Boolean, default: false},
        },
        computed: {
          ...mapGetters('global', [
            'isMobile',
          ]),
            styleObject: function () {

              if(this.withoutColor){
                return {
                  '--width': this.value/10+'%',
                  '--curhue': 190,
                  '--curlight': '100%',
                  '--curlightback': '70%',
                  '--cursaturation': '0%',
                  '--curopacity': '0.12'

                }
              }
              else{
                return {
                  '--width': this.value/10+'%',
                  '--curhue': this.hue,
                  '--curlight': '30%',
                  '--curlightback': '60%',
                  '--cursaturation': '100%',
                  '--curopacity': '0.3'

                }
              }

            }
        },

        methods: {
            stepsCount: function () {
                this.value++;

                    //clearInterval(this.sessionProgress);

                if (this.value >= 1000) {
                    this.$emit('timerOut');
                    clearInterval(this.sessionProgress);
                }
            },
        },
        data() {
            return {
                sessionProgress: 0,
            }
        },
    }
</script>

<style scoped>
    .custom-progress-bar-back {
      position: relative;
      width: 100%;
      background-color: hsla(var(--curhue),var(--cursaturation),var(--curlightback),var(--curopacity));
      height: 0.3vw;
      border-radius: 0.3vw;
    }
    .custom-progress-bar {
      background-color: hsla(var(--curhue),100%,var(--curlight),1);
      position: absolute;
      top: 0;
      left: 0;
      width: var(--width);
      height: 0.3vw;
      border-radius: 0.3vw;
      transition: width 1s;
    }
    @media screen and (max-device-width: 767px) {
      .custom-progress-bar, .custom-progress-bar-back {
        height: 1.2vw;
        border-radius: 1.2vw;
      }
    }
</style>